import Heading from '@/components/ui/heading/heading';
export default Heading;
